import AuthTitle from 'components/AuthTitle';
import Section from 'components/Section';
import { Typography } from '@mui/material';
import Subtitle from 'components/Subtitle';
import { useTranslation } from 'react-i18next';
import styles from '../styles.module.css';

export default function TermsAndServicesSpanish() {
  const { t } = useTranslation();

  return (
    <Section className={styles.section}>
      <AuthTitle>{t('auth.terms-and-service-es.title00')}</AuthTitle>

      <Subtitle>{t('auth.terms-and-service-es.title01')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text00')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text01')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title02')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text02')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text03')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text04')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text05')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text06')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text07')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text08')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text09')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text10')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title03')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text11')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text12')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text13')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text14')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title04')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text15')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text16')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text17')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title05')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text18')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title06')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text19')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text20')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text21')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text22')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text23')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text24')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title07')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text25')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text26')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text27')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text28')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text29')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text30')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title08')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text31')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title09')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text32')}
        <br />
        <br />
      </Typography>

      <Subtitle>{t('auth.terms-and-service-es.title10')}</Subtitle>
      <Typography variant="body2" color="secondary" marginBottom="24px">
        {t('auth.terms-and-service-es.text33')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text34')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text35')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text36')}
        <br />
        <br />
        {t('auth.terms-and-service-es.text37')}
        <br />
        <br />
      </Typography>
    </Section>
  );
}
